// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Inter-Regular400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Inter-Medium500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Inter-SemiBold600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Inter-Bold700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Document
 * ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 */
:where(html) {
  line-height: 1.15; /* 1 */
}
/* Sections
 * ========================================================================== */
/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Edge, Firefox, and Safari.
 */
:where(h1) {
  font-size: 2em;
  margin-block-end: 0.67em;
  margin-block-start: 0.67em;
}
/* Grouping content
 * ========================================================================== */
/**
 * Remove the margin on nested lists in Chrome, Edge, and Safari.
 */
:where(dl, ol, ul) :where(dl, ol, ul) {
  margin-block-end: 0;
  margin-block-start: 0;
}
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Correct the inheritance of border color in Firefox.
 */
:where(hr) {
  box-sizing: content-box; /* 1 */
  color: inherit; /* 2 */
  height: 0; /* 1 */
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
:where(pre) {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/* Text-level semantics
 * ========================================================================== */
/**
 * Add the correct text decoration in Safari.
 */
:where(abbr[title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
:where(b, strong) {
  font-weight: bolder;
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
:where(code, kbd, samp) {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/**
 * Add the correct font size in all browsers.
 */
:where(small) {
  font-size: 80%;
}
/* Tabular data
 * ========================================================================== */
/**
 * 1. Correct table border color in Chrome, Edge, and Safari.
 * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.
 */
:where(table) {
  border-color: currentColor; /* 1 */
  text-indent: 0; /* 2 */
}
/* Forms
 * ========================================================================== */
/**
 * Remove the margin on controls in Safari.
 */
:where(button, input, select) {
  margin: 0;
}
/**
 * Remove the inheritance of text transform in Firefox.
 */
:where(button) {
  text-transform: none;
}
/**
 * Correct the inability to style buttons in iOS and Safari.
 */
:where(button, input:is([type="button" i], [type="reset" i], [type="submit" i])) {
  -webkit-appearance: button;
}
/**
 * Add the correct vertical alignment in Chrome, Edge, and Firefox.
 */
:where(progress) {
  vertical-align: baseline;
}
/**
 * Remove the inheritance of text transform in Firefox.
 */
:where(select) {
  text-transform: none;
}
/**
 * Remove the margin in Firefox and Safari.
 */
:where(textarea) {
  margin: 0;
}
/**
 * 1. Correct the odd appearance in Chrome, Edge, and Safari.
 * 2. Correct the outline style in Safari.
 */
:where(input[type="search" i]) {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/**
 * Correct the cursor style of increment and decrement buttons in Safari.
 */
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/**
 * Correct the text style of placeholders in Chrome, Edge, and Safari.
 */
::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}
/**
 * Remove the inner padding in Chrome, Edge, and Safari on macOS.
 */
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/**
 * 1. Correct the inability to style upload buttons in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/**
 * Remove the inner border and padding of focus outlines in Firefox.
 */
:where(button, input:is([type="button" i], [type="color" i], [type="reset" i], [type="submit" i]))::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
/**
 * Restore the focus outline styles unset by the previous rule in Firefox.
 */
:where(button, input:is([type="button" i], [type="color" i], [type="reset" i], [type="submit" i]))::-moz-focusring {
  outline: 1px dotted ButtonText;
}
/**
 * Remove the additional :invalid styles in Firefox.
 */
:where(:-moz-ui-invalid) {
  box-shadow: none;
}
/* Interactive
 * ========================================================================== */
/*
 * Add the correct styles in Safari.
 */
:where(dialog) {
  background-color: white;
  border: solid;
  color: black;
  height: -moz-fit-content;
  height: fit-content;
  left: 0;
  margin: auto;
  padding: 1em;
  position: absolute;
  right: 0;
  width: -moz-fit-content;
  width: fit-content;
}
:where(dialog:not([open])) {
  display: none;
}
/*
 * Add the correct display in all browsers.
 */
:where(summary) {
  display: list-item;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
html,
body,
#root {
  width: 100%;
  min-height: 100%;
  margin: 0;
}

a {
  text-decoration: none;
}

/* Override Inspinia styles start */
.navbar-top-links li a {
  padding-right: 25px !important;
}

.has-error .form-control,
.has-error .pretty.p-inspinia,
.form-group.has-error .form-control,
.form-group.has-error .pretty.p-inspinia,
.form-group.has-error .c-select {
  margin-bottom: 5px;
}

.ibox-content {
  padding: 20px;
}

.page-heading {
  padding: 0 10px 10px 10px;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}

.close:hover {
  color: #000;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled) {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  appearance: none;
}

a.close.disabled {
  pointer-events: none;
}

.modal-header, .modal-body {
  padding: 1rem !important;
}

/* Override Inspinia styles end */
/* Override React-Datepicker */
.react-datepicker-wrapper {
  width: 100%;
}

/* Override React-Datepicker start */
.custom-datepicker .react-datepicker__day--keyboard-selected,
.custom-datepicker .react-datepicker__day--keyboard-selected:hover {
  background-color: #1ab394;
}

.custom-datepicker.react-datepicker {
  border: 1px solid #e5e6e7;
  border-radius: 1px;
}

.custom-datepicker .react-datepicker__day--in-selecting-range {
  background-color: #1ab3941a;
  color: #000;
}

.custom-datepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start,
.custom-datepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end,
.custom-datepicker .react-datepicker__day--in-range,
.custom-datepicker .react-datepicker__day--selected {
  background-color: #1ab39454;
  color: #000;
}

/* Override React-Datepicker end */
/* Override Toast start */
.Toastify__toast--success {
  background: #1ab394 !important;
}

/*.Toastify__toast--warning {*/
/*    background: #f8ac59 !important;*/
/*}*/
.Toastify__toast--error {
  background: #ED5565 !important;
}

/* Override Toast end */
.react-tel-input .selected-flag .arrow {
  left: 9px !important;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef !important;
  opacity: 1;
}

/* Override Carousel start */
.carousel-caption {
  z-index: 99;
}

.carousel-indicators {
  top: 0;
  bottom: auto;
}

.carousel-control-prev,
.carousel-control-next {
  filter: invert(70%);
  transform: scale(1.2);
}

/* Override Carousel end */
.required-field {
  color: rgba(255, 50, 27, 0.8);
  font-weight: bolder;
}

.logo-wrapper {
  font-size: 24px;
  margin: 5px 20px 20px 20px;
}
.logo-wrapper svg {
  margin-right: 20px;
  width: 120px;
}

.mini-navbar .logo-wrapper {
  display: none;
}

table th, table td {
  text-align: center;
}

.clickable {
  cursor: pointer;
}

.page_heading {
  color: #131A26;
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;
}

.rs-modal-header .rs-modal-header-close {
  font-size: 20px !important;
}

h3 {
  font-size: 17px !important;
  margin-top: 0 !important;
  color: #242424 !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  font-family: Inter !important;
}

.h3_title {
  margin: 5px 0 0 0 !important;
}

.incidents {
  position: relative;
}

.h3_title_incidents {
  display: flex;
}

.incidents_head {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 30px;
  justify-content: space-between;
}

.rs-btn-ghost.rs-btn svg {
  min-width: 20px !important;
}

@media (max-width: 550px) {
  .rs-modal-content {
    padding: 25px 15px 15px 15px !important;
  }

  .rs-modal-title {
    font-size: 16px !important;
  }

  .rs-modal-md {
    width: auto;
  }
}
.text-medium {
  font-size: 18px;
}

.monitor_incident_title {
  margin: 0 0 12px 30px;
}

.monitor_incident_container {
  margin-top: 30px;
}

@media (max-width: 700px) {
  .recharts-layer.recharts-cartesian-axis-tick {
    font-size: 11px;
  }
}

.monitor_head {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: min-content;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./node_modules/@csstools/normalize.css/normalize.css","webpack://./src/styles/vendors/fonts.scss","webpack://./src/styles/globals.scss"],"names":[],"mappings":"AAAA;+EAC+E;AAE/E;;EAEE;AAEF;EACE,iBAAiB,EAAE,MAAM;AAC3B;AAEA;+EAC+E;AAE/E;;;EAGE;AAEF;EACE,cAAc;EACd,wBAAwB;EACxB,0BAA0B;AAC5B;AAEA;+EAC+E;AAE/E;;EAEE;AAEF;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AAEA;;;EAGE;AAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;AACnB;AAEA;;;EAGE;AAEF;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;AAEA;+EAC+E;AAE/E;;EAEE;AAEF;EACE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;AAEA;;EAEE;AAEF;EACE,mBAAmB;AACrB;AAEA;;;EAGE;AAEF;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;AAEA;;EAEE;AAEF;EACE,cAAc;AAChB;AAEA;+EAC+E;AAE/E;;;EAGE;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,cAAc,EAAE,MAAM;AACxB;AAEA;+EAC+E;AAE/E;;EAEE;AAEF;EACE,SAAS;AACX;AAEA;;EAEE;AAEF;EACE,oBAAoB;AACtB;AAEA;;EAEE;AAEF;EACE,0BAA0B;AAC5B;AAEA;;EAEE;AAEF;EACE,wBAAwB;AAC1B;AAEA;;EAEE;AAEF;EACE,oBAAoB;AACtB;AAEA;;EAEE;AAEF;EACE,SAAS;AACX;AAEA;;;EAGE;AAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;AAEA;;EAEE;AAEF;;EAEE,YAAY;AACd;AAEA;;EAEE;AAEF;EACE,cAAc;EACd,aAAa;AACf;AAEA;;EAEE;AAEF;EACE,wBAAwB;AAC1B;AAEA;;;EAGE;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;AAEA;;EAEE;AAEF;EACE,kBAAkB;EAClB,UAAU;AACZ;AAEA;;EAEE;AAEF;EACE,8BAA8B;AAChC;AAEA;;EAEE;AAEF;EACE,gBAAgB;AAClB;AAEA;+EAC+E;AAE/E;;EAEE;AAEF;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;;EAEE;AAEF;EACE,kBAAkB;AACpB;ACvQA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACEF;ADCA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACDF;AAvBA;;;EAGE,WAAA;EACA,gBAAA;EACA,SAAA;AAyBF;;AAtBA;EACE,qBAAA;AAyBF;;AAtBA,mCAAA;AACA;EACE,8BAAA;AAyBF;;AAtBA;;;;;EAKE,kBAAA;AAyBF;;AAtBA;EACE,aAAA;AAyBF;;AAtBA;EACE,yBAAA;AAyBF;;AAtBA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AAyBF;;AAtBA;EACE,WAAA;EACA,qBAAA;AAyBF;;AAtBA;EACE,aAAA;AAyBF;;AAtBA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AAyBF;;AAtBA;EACE,oBAAA;AAyBF;;AAtBA;EACE,wBAAA;AAyBF;;AAtBA,iCAAA;AAEA,8BAAA;AACA;EACE,WAAA;AAwBF;;AArBA,oCAAA;AACA;;EAEE,yBAAA;AAwBF;;AArBA;EACE,yBAAA;EACA,kBAAA;AAwBF;;AArBA;EACE,2BAAA;EACA,WAAA;AAwBF;;AArBA;;;;EAIE,2BAAA;EACA,WAAA;AAwBF;;AArBA,kCAAA;AAEA,yBAAA;AACA;EACE,8BAAA;AAuBF;;AApBA,8BAAA;AACA,sCAAA;AACA,IAAA;AAEA;EACE,8BAAA;AAsBF;;AAnBA,uBAAA;AAEA;EACE,oBAAA;AAqBF;;AAlBA;EACE,oCAAA;EACA,UAAA;AAqBF;;AAlBA,4BAAA;AAEA;EACE,WAAA;AAoBF;;AAjBA;EACE,MAAA;EACA,YAAA;AAoBF;;AAjBA;;EAEE,mBAAA;EACA,qBAAA;AAoBF;;AAjBA,0BAAA;AACA;EACE,6BAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,0BAAA;AAoBF;AAlBE;EACE,kBAAA;EACA,YAAA;AAoBJ;;AAfE;EACE,aAAA;AAkBJ;;AAbE;EACE,kBAAA;AAgBJ;;AAZA;EACE,eAAA;AAeF;;AAZA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAeF;;AAZA;EACE,0BAAA;AAeF;;AAZA;EACE,0BAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;AAeF;;AAZA;EACE,4BAAA;AAeF;;AAXA;EACE,kBAAA;AAcF;;AAXA;EACE,aAAA;AAcF;;AAXA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAcF;;AAXA;EACE,0BAAA;AAcF;;AAXA;EACE;IACE,uCAAA;EAcF;;EAXA;IACE,0BAAA;EAcF;;EAXA;IACE,WAAA;EAcF;AACF;AAXA;EACE,eAAA;AAaF;;AAVA;EACE,qBAAA;AAaF;;AAVA;EACE,gBAAA;AAaF;;AATE;EADF;IAEI,eAAA;EAaF;AACF;;AAVA;EACE,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;AAaF","sourcesContent":["/* Document\n * ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n */\n\n:where(html) {\n  line-height: 1.15; /* 1 */\n}\n\n/* Sections\n * ========================================================================== */\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Edge, Firefox, and Safari.\n */\n\n:where(h1) {\n  font-size: 2em;\n  margin-block-end: 0.67em;\n  margin-block-start: 0.67em;\n}\n\n/* Grouping content\n * ========================================================================== */\n\n/**\n * Remove the margin on nested lists in Chrome, Edge, and Safari.\n */\n\n:where(dl, ol, ul) :where(dl, ol, ul) {\n  margin-block-end: 0;\n  margin-block-start: 0;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Correct the inheritance of border color in Firefox.\n */\n\n:where(hr) {\n  box-sizing: content-box; /* 1 */\n  color: inherit; /* 2 */\n  height: 0; /* 1 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\n:where(pre) {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n * ========================================================================== */\n\n/**\n * Add the correct text decoration in Safari.\n */\n\n:where(abbr[title]) {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\n:where(b, strong) {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\n:where(code, kbd, samp) {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\n:where(small) {\n  font-size: 80%;\n}\n\n/* Tabular data\n * ========================================================================== */\n\n/**\n * 1. Correct table border color in Chrome, Edge, and Safari.\n * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.\n */\n\n:where(table) {\n  border-color: currentColor; /* 1 */\n  text-indent: 0; /* 2 */\n}\n\n/* Forms\n * ========================================================================== */\n\n/**\n * Remove the margin on controls in Safari.\n */\n\n:where(button, input, select) {\n  margin: 0;\n}\n\n/**\n * Remove the inheritance of text transform in Firefox.\n */\n\n:where(button) {\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style buttons in iOS and Safari.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"reset\" i], [type=\"submit\" i])) {\n  -webkit-appearance: button;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Edge, and Firefox.\n */\n\n:where(progress) {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the inheritance of text transform in Firefox.\n */\n\n:where(select) {\n  text-transform: none;\n}\n\n/**\n * Remove the margin in Firefox and Safari.\n */\n\n:where(textarea) {\n  margin: 0;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome, Edge, and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n:where(input[type=\"search\" i]) {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Safari.\n */\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * Remove the inner padding in Chrome, Edge, and Safari on macOS.\n */\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style upload buttons in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/**\n * Remove the inner border and padding of focus outlines in Firefox.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"color\" i], [type=\"reset\" i], [type=\"submit\" i]))::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus outline styles unset by the previous rule in Firefox.\n */\n\n:where(button, input:is([type=\"button\" i], [type=\"color\" i], [type=\"reset\" i], [type=\"submit\" i]))::-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Remove the additional :invalid styles in Firefox.\n */\n\n:where(:-moz-ui-invalid) {\n  box-shadow: none;\n}\n\n/* Interactive\n * ========================================================================== */\n\n/*\n * Add the correct styles in Safari.\n */\n\n:where(dialog) {\n  background-color: white;\n  border: solid;\n  color: black;\n  height: -moz-fit-content;\n  height: fit-content;\n  left: 0;\n  margin: auto;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n:where(dialog:not([open])) {\n  display: none;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\n:where(summary) {\n  display: list-item;\n}\n","@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Regular400.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Medium500.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-SemiBold600.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Bold700.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}","//noinspection CssInvalidAtRule\n@import-normalize;\n@import \"./vendors/fonts\";\n@import \"./vendors/mixins\";\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  min-height: 100%;\n  margin: 0;\n}\n\na {\n  text-decoration: none;\n}\n\n/* Override Inspinia styles start */\n.navbar-top-links li a {\n  padding-right: 25px !important;\n}\n\n.has-error .form-control,\n.has-error .pretty.p-inspinia,\n.form-group.has-error .form-control,\n.form-group.has-error .pretty.p-inspinia,\n.form-group.has-error .c-select {\n  margin-bottom: 5px;\n}\n\n.ibox-content {\n  padding: 20px;\n}\n\n.page-heading {\n  padding: 0 10px 10px 10px;\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n\n.close:hover {\n  color: #000;\n  text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled) {\n  opacity: .75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.modal-header, .modal-body {\n  padding: 1rem !important;\n}\n\n/* Override Inspinia styles end */\n\n/* Override React-Datepicker */\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n/* Override React-Datepicker start */\n.custom-datepicker .react-datepicker__day--keyboard-selected,\n.custom-datepicker .react-datepicker__day--keyboard-selected:hover {\n  background-color: #1ab394;\n}\n\n.custom-datepicker.react-datepicker {\n  border: 1px solid #e5e6e7;\n  border-radius: 1px;\n}\n\n.custom-datepicker .react-datepicker__day--in-selecting-range {\n  background-color: #1ab3941a;\n  color: #000;\n}\n\n.custom-datepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start,\n.custom-datepicker .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end,\n.custom-datepicker .react-datepicker__day--in-range,\n.custom-datepicker .react-datepicker__day--selected {\n  background-color: #1ab39454;\n  color: #000;\n}\n\n/* Override React-Datepicker end */\n\n/* Override Toast start */\n.Toastify__toast--success {\n  background: #1ab394 !important;\n}\n\n/*.Toastify__toast--warning {*/\n/*    background: #f8ac59 !important;*/\n/*}*/\n\n.Toastify__toast--error {\n  background: #ED5565 !important;\n}\n\n/* Override Toast end */\n\n.react-tel-input .selected-flag .arrow {\n  left: 9px !important;\n}\n\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef !important;\n  opacity: 1;\n}\n\n/* Override Carousel start */\n\n.carousel-caption {\n  z-index: 99;\n}\n\n.carousel-indicators {\n  top: 0;\n  bottom: auto;\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  filter: invert(70%);\n  transform: scale(1.2);\n}\n\n/* Override Carousel end */\n.required-field {\n  color: rgba(255, 50, 27, 0.8);\n  font-weight: bolder;\n}\n\n.logo-wrapper {\n  font-size: 24px;\n  margin: 5px 20px 20px 20px;\n\n  svg {\n    margin-right: 20px;\n    width: 120px;\n  }\n}\n\n.mini-navbar {\n  .logo-wrapper {\n    display: none;\n  }\n}\n\ntable {\n  th, td {\n    text-align: center;\n  }\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.page_heading {\n  color: #131A26;\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 24px;\n}\n\n.rs-modal-header .rs-modal-header-close {\n  font-size: 20px !important;\n}\n\nh3 {\n  font-size: 17px !important;\n  margin-top: 0 !important;\n  color: #242424 !important;\n  font-weight: 600 !important;\n  line-height: 1.5 !important;\n  font-family: Inter !important;\n}\n\n.h3_title {\n  margin: 5px 0 0 0 !important;\n}\n\n\n.incidents {\n  position: relative;\n}\n\n.h3_title_incidents {\n  display: flex;\n}\n\n.incidents_head {\n  display: flex;\n  gap: 30px;\n  align-items: center;\n  margin-bottom: 12px;\n  padding: 0 30px;\n  justify-content: space-between;\n}\n\n.rs-btn-ghost.rs-btn svg {\n  min-width: 20px !important;\n}\n\n@media (max-width: 550px) {\n  .rs-modal-content {\n    padding: 25px 15px 15px 15px !important;\n  }\n\n  .rs-modal-title {\n    font-size: 16px !important;\n  }\n\n  .rs-modal-md {\n    width: auto;\n  }\n}\n\n.text-medium {\n  font-size: 18px;\n}\n\n.monitor_incident_title {\n  margin: 0 0 12px 30px;\n}\n\n.monitor_incident_container {\n  margin-top: 30px;\n}\n\n.recharts-layer.recharts-cartesian-axis-tick {\n  @media(max-width: 700px) {\n    font-size: 11px;\n  }\n}\n\n.monitor_head {\n  display: grid;\n  grid-template-columns: 50% 50%;\n  grid-template-rows: min-content;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
